'use strict';
/* eslint-disable react/no-did-mount-set-state */

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'CSSHeightTransition',

  propTypes: {
    className: _react.PropTypes.string,
    contentClassName: _react.PropTypes.string,
    open: _react.PropTypes.bool.isRequired,
    style: _react.PropTypes.object,
    animationTiming: _react.PropTypes.number.isRequired,
    children: _react.PropTypes.node
  },

  getInitialState: function getInitialState() {
    return {
      height: 0,
      isAnimating: false
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // Render in "animating" state. Animation will begin in componentDidUpdate().
    if (this.props.open !== nextProps.open) {
      this.setState({
        height: this.computeContentHeight(),
        isAnimating: true
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var open = this.props.open;


    var opened = !prevProps.open && open;
    var closed = prevProps.open && !open;

    if (closed) {
      // set a timeout so that the isAnimating state change makes its way to
      // the DOM and we have a fixed start height on our wrapper element
      this.animateWrapperHeight(this.computeContentHeight(), 0);
    } else if (opened) {
      this.animateWrapperHeight(0, this.computeContentHeight());
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.clearTimers();
  },
  animateWrapperHeight: function animateWrapperHeight(initialHeight, newHeight) {
    var _this = this;

    this.clearTimers();
    this.setState({
      height: initialHeight
    });
    this._frame = requestAnimationFrame(function () {
      _this._frame = requestAnimationFrame(function () {
        _this.setState({
          height: newHeight
        });
        _this.setAnimationTimeout();
      });
    });
  },
  stopAnimation: function stopAnimation() {
    this.setState({
      isAnimating: false
    });
  },
  setAnimationTimeout: function setAnimationTimeout() {
    var animationTiming = this.props.animationTiming;

    this._animationTimeout = setTimeout(this.stopAnimation, animationTiming);
  },
  clearTimers: function clearTimers() {
    cancelAnimationFrame(this._frame);
    clearTimeout(this._animationTimeout);
  },
  contentRefCallback: function contentRefCallback(ref) {
    this._content = ref;
  },
  computeContentHeight: function computeContentHeight() {
    return this._content.scrollHeight;
  },
  getWrapperStyle: function getWrapperStyle() {
    var _state = this.state,
        height = _state.height,
        isAnimating = _state.isAnimating;


    if (isAnimating) {
      return { height: height };
    }

    return {};
  },
  render: function render() {
    var _props = this.props,
        open = _props.open,
        className = _props.className,
        contentClassName = _props.contentClassName,
        style = _props.style,
        children = _props.children;
    var isAnimating = this.state.isAnimating;


    var wrapperClasses = (0, _reactUtils.classNames)(className, 'private-height-transition', {
      'private-height-transition--closed': !open,
      'private-height-transition--animating': isAnimating
    });
    var contentClasses = (0, _reactUtils.classNames)(contentClassName, 'private-height-transition--content');

    return _react2.default.createElement(
      'div',
      {
        ref: this.onWrapperRef,
        className: wrapperClasses,
        style: _extends({}, this.getWrapperStyle(), style)
      },
      _react2.default.createElement(
        'div',
        { ref: this.contentRefCallback, className: contentClasses },
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/animation/CSSHeightTransition.js
// module id = 436
// module chunks = 0